import styled from "styled-components";

export const ProfileContactWrapper = styled.div`
    display: flex;
	width: 100%;
	background-color: var(--white);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
    border-radius: 10px;
    padding: 24px;
    flex-wrap: wrap;
    .contactRow{
        display: flex;
        width: 100%;
        p{
            max-width: 200px;
            min-width: 200px;
        }
    }
    @media (max-width: 767px) {
        padding: 16px 16px 16px 16px;
        box-shadow: none;
        border-radius: 0px;
        .contactRow{
            p{
                max-width: 150px;
                min-width: 150px;
            }
        }
    }
    @media (max-width: 399px) {
        .contactRow{
            /* flex-wrap: wrap; */
            p{
                max-width: auto;
                min-width: auto;
                /* max-width: 100%;
                min-width: 100%; */
            }
        }
    }
`